import {Action} from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {PaginationModel} from "@shared/models/pagination.model";
import {BillingTransactionSearchModel} from "@services/back-office/model/billingTransactionSearchModel";
import {PageBillingTransactionModel} from "@services/back-office/model/pageBillingTransactionModel";
import {BillingTransactionModel} from "@services/back-office/model/billingTransactionModel";

export enum PaymentsActionTypes {
    LoadPayments = '[Payments] Load Payments',
    LoadPaymentsSuccess = '[Payments] Load Payments Success',
    LoadPaymentsFailure = '[Payments] Load Payments Failure',
    EditPayment = '[Payment] Edit Payments',
    EditPaymentSuccess = '[Payment] Edit Payments Success',
    EditPaymentFailure = '[Payment] Edit Payments Failure',
    DeletePayment = '[Payment] Delete Payments',
    DeletePaymentSuccess = '[Payment] Delete Payments Success',
    DeletePaymentFailure = '[Payment] Delete Payments Failure',
    ChangePage = '[Payments] Change Page',
    SetInitialPagination = '[Payments] Set Initial Pagination',
    SetFilter = '[Payments] Set Filter',
    ClearFilter = '[Payments] Clear Filter',
    SetInitialState = '[Payments] Set Initial State',
}

export class LoadPayments implements Action {
    readonly type = PaymentsActionTypes.LoadPayments;
    constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadPaymentsSuccess implements Action {
    readonly type = PaymentsActionTypes.LoadPaymentsSuccess;
    constructor(public payload: PageBillingTransactionModel) { }
}

export class LoadPaymentsFailure implements Action {
    readonly type = PaymentsActionTypes.LoadPaymentsFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export class EditPayment implements Action {
    readonly type = PaymentsActionTypes.EditPayment;
    constructor(public payload: BillingTransactionModel) {}
}

export class EditPaymentSuccess implements Action {
    readonly type = PaymentsActionTypes.EditPaymentSuccess;
    constructor(public payload: BillingTransactionModel) { }
}

export class EditPaymentFailure implements Action {
    readonly type = PaymentsActionTypes.EditPaymentFailure;
    constructor(public payload: HttpErrorResponse) { }
}

export class DeletePayment implements Action {
    readonly type = PaymentsActionTypes.DeletePayment;
    constructor(public payload: string) {}
}

export class DeletePaymentSuccess implements Action {
    readonly type = PaymentsActionTypes.DeletePaymentSuccess;
    constructor(public payload: string) { }
}

export class DeletePaymentFailure implements Action {
    readonly type = PaymentsActionTypes.DeletePaymentFailure;
    constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
    readonly type = PaymentsActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = PaymentsActionTypes.SetInitialPagination;
}

export class SetFilter implements Action {
    readonly type = PaymentsActionTypes.SetFilter;
    constructor(public payload: BillingTransactionSearchModel) { }
}

export class ClearFilter implements Action {
    readonly type = PaymentsActionTypes.ClearFilter;
}

export class SetInitialState implements Action {
    readonly type = PaymentsActionTypes.SetInitialState;
}

export type PaymentsActions =
    | LoadPayments
    | LoadPaymentsSuccess
    | LoadPaymentsFailure
    | EditPayment
    | EditPaymentSuccess
    | EditPaymentFailure
    | DeletePayment
    | DeletePaymentSuccess
    | DeletePaymentFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    ;
